import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames/bind";
import { observer } from "mobx-react";

import Tooltip from "@components/tooltip";

import RecurrentPayment from "./RecurrentPayment";

import formatDate from "../../../../../utils/formatDate";
import { sendNavigationMetric } from "../../../../../utils/sendMetric";

import { useStore } from "../../../../../connect";

import strings from "../../../../../locales/strings";
import interpolate from "../../../../../locales/interpolate";

import styles from "../ProfileDropdown.scss";

const cx = classnames.bind(styles);

const LicensePaid = ({ expired }) => {
  const { profile, baseUrl } = useStore();

  const disableLink = (event) => {
    event.preventDefault();
  };

  if (expired) {
    const isDisableAdd =
      profile.payedServices.profileDropdownLicenses.remainingDays <= 1;

    return (
      <div className={cx("license-paid-area")}>
        <div className={cx("payed-days", "expired")}>
          {interpolate(strings.profile_paidFor, {
            val: formatDate(
              profile.payedServices.profileDropdownLicenses.endDate
            ),
          })}
          <span className={cx("days-payed")}>
            ({profile.payedServices.profileDropdownLicenses.remainingDays}&nbsp;
            {strings.profile_days})
          </span>
        </div>

        <RecurrentPayment />

        <div className={cx("license-paid-area-button-block")}>
          <a
            href={`https://billing.${baseUrl}/addinvoice?option=1&utm_source=header&utm_campaign=new_header&utm_content=header_addinvoice`}
            className={cx(
              "glz-button",
              "glz-is-small",
              "glz-is-primary",
              "extend-button"
            )}
            onClick={() => sendNavigationMetric("LICENSE_PAID_EXTEND")}
          >
            {strings.profile_extend}
          </a>

          <Tooltip
            disabled={!isDisableAdd}
            isWithoutWrapper
            content={
              <span>
                {strings.profile_addingNewLicenses}
                <br />
                {strings.profile_WillBeAvailableAfterRenewal}
              </span>
            }
          >
            <a
              href={`https://billing.${baseUrl}/addinvoice?option=2&utm_source=header&utm_campaign=new_header&utm_content=header_addinvoice`}
              className={cx("glz-link", "add-btn", {
                "glz-is-disabled": isDisableAdd,
              })}
              onClick={
                isDisableAdd
                  ? disableLink
                  : () => sendNavigationMetric("LICENSE_PAID_ADD")
              }
            >
              {strings.profile_add}
            </a>
          </Tooltip>
        </div>
      </div>
    );
  }

  return (
    <div className={cx("license-paid-area")}>
      <div className={cx("payed-days")}>
        {interpolate(strings.profile_paidFor, {
          val: formatDate(
            profile.payedServices.profileDropdownLicenses.endDate
          ),
        })}
        ({profile.payedServices.profileDropdownLicenses.remainingDays}&nbsp;
        {strings.profile_days})
      </div>

      <RecurrentPayment />
    </div>
  );
};

LicensePaid.propTypes = {
  expired: PropTypes.bool,
};

export default observer(LicensePaid);
